import { useState } from "react";

const steps = [
  {
    num: "01",
    title: "Submit Details",
    desc: "Fill in tenant, owner, property address, rent amount, and agreement duration.",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
      </svg>
    ),
  },
  {
    num: "02",
    title: "Document Verification",
    desc: "Upload ID proof (Aadhaar/PAN) and address proof for quick verification.",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
  },
  {
    num: "03",
    title: "Make Payment",
    desc: "Pay starting from ₹499 (delivery charges extra).",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
      </svg>
    ),
  },
  {
    num: "04",
    title: "Draft Preparation",
    desc: "Our team prepares your rental agreement in legal format.",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
  },
  {
    num: "05",
    title: "Review & Confirm",
    desc: "Check all details and approve the draft.",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
    ),
  },
  {
    num: "06",
    title: "Delivery / Pickup",
    desc: "Agreement delivered to your doorstep in Bangalore or shared digitally for review.",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
      </svg>
    ),
  },
  {
    num: "07",
    title: "Registration Support",
    desc: "Assistance with e-stamping / registration if required. (Optional)",
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
      </svg>
    ),
  },
];

const features = [
  {
    title: "Legally Compliant",
    desc: "Drafted by legal experts, fully compliant with local rental laws.",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6l3 1m0 0l-3 9a5.002 5.002 0 006.001 0M6 7l3 9M6 7l6-2m6 2l3-1m-3 1l-3 9a5.002 5.002 0 006.001 0M18 7l3 9m-3-9l-6-2m0-2v2m0 16V5m0 16H9m3 0h3" />
      </svg>
    ),
  },
  {
    title: "Affordable Pricing",
    desc: "Starting at just ₹499 — transparent pricing with no hidden charges.",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
    ),
  },
  {
    title: "Fast Turnaround",
    desc: "Quick processing and timely delivery so you never have to wait long.",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
      </svg>
    ),
  },
  {
    title: "Doorstep Delivery",
    desc: "Physical agreement delivered right to your address across Bangalore.",
    icon: (
      <svg className="w-7 h-7" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
  },
];

const tags = ["Simple", "Fast", "Legal", "Reliable"];

export default function RentalAgreements() {
  const [activeStep, setActiveStep] = useState(null);

  return (
    <div className="bg-white min-h-screen -mt-24">

      {/* ── HERO SECTION ── */}
      <section className="relative overflow-hidden bg-gradient-to-br from-[#fff5f5] to-white">
        {/* decorative blobs */}
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-red-100 opacity-50 blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-64 h-64 rounded-full bg-red-50 opacity-60 blur-2xl pointer-events-none" />

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">

            {/* Left */}
            <div>
              <span className="inline-block bg-red-100 text-[#e63027] text-xs font-semibold tracking-widest uppercase px-4 py-1.5 rounded-full mb-6">
                Rental Agreements
              </span>
              <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6">
                Professional<br />
                Rental Agreements<br />
                <span className="text-[#e63027]">Made Simple</span>
              </h1>
              <p className="text-gray-600 text-lg leading-relaxed mb-8 max-w-lg">
                Get legally drafted rental agreements quickly and hassle-free with HousyHunt. Whether you're a property owner or tenant, we ensure smooth documentation with a simple process, transparent pricing, and reliable support.
              </p>

              {/* Price badge */}
              <div className="flex flex-wrap items-center gap-4 mb-8">
                <div className="flex items-baseline gap-1">
                  <span className="text-4xl font-black text-[#e63027]">₹499</span>
                  <span className="text-gray-500 text-sm">onwards</span>
                </div>
                <div className="h-10 w-px bg-gray-200" />
                <p className="text-gray-500 text-sm leading-snug">
                  Delivery charges apply<br />
                  <span className="font-semibold text-gray-700">Bangalore only</span>
                </p>
              </div>

              <div className="flex flex-wrap gap-3">
                <button className="bg-[#e63027] hover:bg-[#c9251d] text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 shadow-lg shadow-red-200 hover:shadow-red-300 hover:-translate-y-0.5">
                  Get Started →
                </button>
                <button className="border-2 border-gray-200 hover:border-[#e63027] text-gray-700 hover:text-[#e63027] font-semibold px-8 py-3.5 rounded-full transition-all duration-200">
                  Learn More
                </button>
              </div>
            </div>

            {/* Right — image card */}
            <div className="relative">
              <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80"
                  alt="Rental Agreement"
                  className="w-full h-80 lg:h-[420px] object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
              </div>

              {/* Floating badges */}
              <div className="absolute -top-4 -left-4 bg-[#e63027] text-white rounded-2xl px-5 py-3 shadow-xl">
                <p className="text-xs font-medium opacity-80">24/7 Support</p>
                <p className="text-lg font-black">Always Available</p>
              </div>
              <div className="absolute -bottom-4 -right-4 bg-white rounded-2xl px-5 py-3 shadow-xl border border-gray-100">
                <p className="text-[#e63027] text-2xl font-black">98.9%</p>
                <p className="text-gray-600 text-xs font-medium">Successful Deals</p>
              </div>

              {/* Tag pills */}
              <div className="absolute bottom-6 left-4 flex flex-wrap gap-2">
                {tags.map((t) => (
                  <span key={t} className="bg-white/90 backdrop-blur-sm text-gray-800 text-xs font-semibold px-3 py-1 rounded-full shadow">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── RED FEATURE STRIP ── */}
      <section className="bg-[#e63027]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-10">
            {features.map((f) => (
              <div key={f.title} className="flex flex-col items-center text-center text-white group">
                <div className="w-14 h-14 bg-white/15 rounded-2xl flex items-center justify-center mb-3 group-hover:bg-white/25 transition-colors duration-200">
                  {f.icon}
                </div>
                <p className="font-bold text-sm sm:text-base leading-tight">{f.title}</p>
                <p className="text-white/70 text-xs mt-1 hidden md:block leading-relaxed">{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── WHY HOUSYHUNT ── */}
      <section className="bg-[#fff5f5] py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

            {/* Text */}
            <div>
              <span className="text-[#e63027] text-xs font-bold tracking-widest uppercase">Why Choose Us</span>
              <h2 className="mt-3 text-3xl sm:text-4xl font-black text-gray-900 leading-snug">
                Fast, Legal &<br />
                <span className="text-[#e63027]">Hassle-Free</span> Rental Agreements
              </h2>
              <p className="mt-5 text-gray-600 leading-relaxed text-lg">
                HousyHunt helps landlords and tenants create legally compliant rental agreements with ease. From drafting to delivery, our team handles the process professionally — saving you time and effort.
              </p>

              <ul className="mt-8 space-y-4">
                {[
                  "Affordable pricing starting from ₹499",
                  "Available across Bangalore",
                  "Delivery charges extra — transparent billing",
                  "Expert legal team handles all documentation",
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="mt-1 flex-shrink-0 w-5 h-5 rounded-full bg-[#e63027] flex items-center justify-center">
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                      </svg>
                    </span>
                    <span className="text-gray-700">{item}</span>
                  </li>
                ))}
              </ul>

              <button className="mt-10 bg-[#e63027] hover:bg-[#c9251d] text-white font-semibold px-8 py-3.5 rounded-full transition-all duration-200 shadow-lg shadow-red-200 hover:-translate-y-0.5 inline-flex items-center gap-2">
                Apply Now
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </button>
            </div>

            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-5">
              {[
                { val: "₹499", label: "Starting Price", sub: "Most affordable in Bangalore" },
                { val: "48hr", label: "Turnaround", sub: "Fast delivery guaranteed" },
                { val: "5000+", label: "Agreements Done", sub: "Trusted by landlords & tenants" },
                { val: "100%", label: "Legally Valid", sub: "Compliant with local laws" },
              ].map((s) => (
                <div key={s.label} className="bg-white rounded-2xl p-6 shadow-sm border border-red-50 hover:border-red-200 transition-colors duration-200">
                  <p className="text-3xl font-black text-[#e63027]">{s.val}</p>
                  <p className="font-bold text-gray-900 mt-1">{s.label}</p>
                  <p className="text-gray-500 text-xs mt-1">{s.sub}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PROCESS STEPS ── */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-14">
            <span className="text-[#e63027] text-xs font-bold tracking-widest uppercase">How It Works</span>
            <h2 className="mt-3 text-3xl sm:text-4xl font-black text-gray-900">
              Rental Agreement – Apply Process
            </h2>
            <p className="mt-4 text-gray-500 max-w-xl mx-auto">
              A simple 7-step process that gets your rental agreement ready quickly and legally.
            </p>
          </div>

          {/* Steps grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {steps.map((step, idx) => (
              <div
                key={step.num}
                onClick={() => setActiveStep(activeStep === idx ? null : idx)}
                className={`relative cursor-pointer rounded-2xl p-6 border-2 transition-all duration-300 group ${
                  activeStep === idx
                    ? "border-[#e63027] bg-[#e63027] text-white shadow-xl shadow-red-200"
                    : "border-gray-100 bg-white hover:border-red-200 hover:shadow-md"
                }`}
              >
                {/* Step number */}
                <span className={`text-6xl font-black leading-none select-none block mb-4 transition-colors duration-300 ${
                  activeStep === idx ? "text-white/20" : "text-gray-100"
                }`}>
                  {step.num}
                </span>

                <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-4 transition-colors duration-300 ${
                  activeStep === idx ? "bg-white/20" : "bg-red-50 text-[#e63027]"
                }`}>
                  {step.icon}
                </div>

                <h3 className={`font-bold text-base mb-2 transition-colors duration-300 ${
                  activeStep === idx ? "text-white" : "text-gray-900"
                }`}>
                  {step.title}
                </h3>
                <p className={`text-sm leading-relaxed transition-colors duration-300 ${
                  activeStep === idx ? "text-white/80" : "text-gray-500"
                }`}>
                  {step.desc}
                </p>

                {/* Optional badge */}
                {step.title.includes("Optional") && (
                  <span className={`mt-3 inline-block text-xs font-semibold px-2 py-0.5 rounded-full ${
                    activeStep === idx ? "bg-white/20 text-white" : "bg-gray-100 text-gray-500"
                  }`}>
                    Optional
                  </span>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── DOCUMENT IMAGE + INFO BAND ── */}
      <section className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-center">

            {/* Image */}
            <div className="lg:col-span-3 relative">
              <div className="rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=900&q=80"
                  alt="Signing rental agreement"
                  className="w-full h-72 sm:h-96 object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent rounded-3xl" />
              </div>
              {/* Overlay card */}
              <div className="absolute bottom-6 left-6 bg-white rounded-2xl px-5 py-4 shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#e63027] flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    </svg>
                  </div>
                  <div>
                    <p className="text-xs text-gray-500">Service area</p>
                    <p className="font-bold text-gray-900 text-sm">Bangalore Only</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right info */}
            <div className="lg:col-span-2">
              <span className="text-[#e63027] text-xs font-bold tracking-widest uppercase">Documentation</span>
              <h2 className="mt-3 text-3xl font-black text-gray-900 leading-snug">
                What You'll<br />Need to Provide
              </h2>
              <p className="mt-4 text-gray-500 leading-relaxed">
                Keep these documents ready to speed up the process.
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  "Tenant & Owner full name and contact details",
                  "Property address with pincode",
                  "Monthly rent amount and security deposit",
                  "Agreement start date and duration",
                  "Aadhaar / PAN card (both parties)",
                  "Address proof document",
                ].map((doc) => (
                  <li key={doc} className="flex items-center gap-3">
                    <span className="w-2 h-2 rounded-full bg-[#e63027] flex-shrink-0" />
                    <span className="text-gray-700 text-sm">{doc}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* ── CTA BANNER ── */}
      <section className="bg-[#e63027] relative overflow-hidden py-16">
        <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-white/10 pointer-events-none" />
        <div className="absolute -bottom-10 -left-10 w-48 h-48 rounded-full bg-white/5 pointer-events-none" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <div className="flex flex-wrap justify-center gap-3 mb-8">
            {tags.map((t) => (
              <span key={t} className="bg-white/20 text-white text-sm font-semibold px-5 py-1.5 rounded-full tracking-wide">
                {t}
              </span>
            ))}
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-white leading-tight">
            Ready to Get Your<br />Rental Agreement?
          </h2>
          <p className="mt-5 text-white/80 text-lg max-w-xl mx-auto">
            Join thousands of landlords and tenants across Bangalore who trust HousyHunt for fast, legal, and affordable rental agreements.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <button className="bg-white hover:bg-gray-50 text-[#e63027] font-bold px-10 py-4 rounded-full transition-all duration-200 shadow-xl hover:-translate-y-0.5">
              Apply Now — Starting ₹499
            </button>
            <button className="border-2 border-white/50 hover:border-white text-white font-semibold px-8 py-4 rounded-full transition-all duration-200">
              Talk to an Expert
            </button>
          </div>
          <p className="mt-6 text-white/60 text-sm">
            Bangalore only · Delivery charges extra · 48-hour turnaround
          </p>
        </div>
      </section>

    </div>
  );
}